import bunqLogo from '../../assets/images/banks/logos/bunq.svg';
export type BanksDataType = typeof bunq;

const bunq = {
  name: 'bunq',
  status: 'available',
  logo: bunqLogo,
  flowScore: 5,
  updatedAt: new Date('Jun 30, 2021'),
  pricePerMonth: {
    personal: '€8,99',
    business: '€10,99',
  },
  pros: [
    '25 IBAN accounts included in plan',
    'Smart payment card management features',
    'Apple Pay support',
    'Debit mastercards',
    'Virtual mastercards',
    'Realtime updates in Flow app',
    'App with many good features',
  ],
  cons: [
    'Relatively high pricing compared to other banks',
    'Cash withdrawals cost money in some cases',
    'Customer service can be faster',
  ],
  features: {
    spending: {
      accounts: 25,
      flowCompatible: true,
    },
    saving: {
      accounts: 25,
      flowCompatible: true,
    },
    investing: {
      hasInvesting: false,
      flowCompatible: false,
    },
  },
  link: '/bunq',
};

const banksData = { bunq };

export default banksData;
